var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-feedback', {
    staticClass: "feedback-section"
  }, [_c('form-label', {
    attrs: {
      "title": "Name"
    }
  }, [_c('input-text'), _vm._v(" "), _c('span', {
    staticClass: "form-naming"
  }, [_vm._v("Name")])], 1), _vm._v(" "), _c('form-label', {
    attrs: {
      "title": "E-mail"
    }
  }, [_c('input-url'), _vm._v(" "), _c('span', {
    staticClass: "form-naming"
  }, [_vm._v(" E-mail ")])], 1), _vm._v(" "), _c('form-label', {
    attrs: {
      "title": "Web site"
    }
  }, [_c('input-email'), _vm._v(" "), _c('span', {
    staticClass: "form-naming"
  }, [_vm._v(" Web site ")])], 1), _vm._v(" "), _c('form-label', {
    attrs: {
      "title": "Comments"
    }
  }, [_c('input-multiline')], 1), _vm._v(" "), _c('button-control', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Send ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2120bc4f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/form-feedback/form-feedback.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2120bc4f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/form-feedback/form-feedback.vue
// module chunks = index